import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import ReactHtmlParser from 'react-html-parser';

import FAQCategoryCollection from '../../../Custom/FAQ/FAQCategoryCollection';
import BreadCrumbs from '../../../Custom/BreadCrumbs';

import {
  StyledContainer,
  Wrapper,
  Category,
  FAQSection,
  StyledFAQSearch,
  Header,
  NavBar,
} from './styles';

const FAQCategory = ({ data }) => {
  if (!data) return null;
  const { faq_category, subCategory, subCatPageSlug } = data;
  const intl = useIntl();
  return (
    <>
      <BreadCrumbs
        className="end-chevron"
        crumbs={[
          {
            label: `${intl.formatMessage({ id: 'learningHub' })}`,
            slug: '/learning-hub',
            active: true,
          },
          {
            label: `${intl.formatMessage({ id: 'FAQs' })}`,
            slug: '/learning-hub/faqs',
            active: true,
          },
        ]}
      />
      <StyledContainer>
        <NavBar>
          <StyledFAQSearch
            type="is-open"
            placeholder={`${intl.formatMessage({
              id: 'FAQSearchPlaceholder',
            })}`}
            predictiveSearch
            predictiveSearchClass="centered-results"
          />
          <Header>{ReactHtmlParser(subCategory)}</Header>
        </NavBar>
        <Wrapper>
          <Category>
            <FAQSection
              containerClass="inner-container no-margin"
              data={data}
            />
          </Category>
          <FAQCategoryCollection
            faqCategory={faq_category}
            activeCategory={subCatPageSlug}
          />
        </Wrapper>
      </StyledContainer>
    </>
  );
};

FAQCategory.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default FAQCategory;
